import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Box } from "@mui/material";
import { GridToolbarQuickFilter, } from "@mui/x-data-grid-pro";
const StyledWrapper = styled(Box)(() => ({
    display: "flex",
    justifyContent: "flex-end",
}));
// TODO: add custom filtering components & custom search bar to this component
export const DataGridProToolBar = (props = {}) => {
    var _a, _b;
    return (_jsx(StyledWrapper, { children: _jsx(GridToolbarQuickFilter, Object.assign({}, props, { debounceMs: (_b = (_a = props === null || props === void 0 ? void 0 : props.quickFilterProps) === null || _a === void 0 ? void 0 : _a.debounceMs) !== null && _b !== void 0 ? _b : 500 })) }));
};
